/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="menu-form-search form-search-wrap" :class="formClass">
    <b-form class="form-search" @submit.prevent="submitForm">
      <div class="wrapp-search">
        <div class="wrapp-icon" v-show="!inputText" @click.prevent="openScanReader">
          <svg class="o-icon"><use xlink:href="#qr-code"></use></svg>
        </div>
        <b-form-group class="search-in-nav">
          <base-input
            name="searchTextInput"
            type="text"
            classInput="rounded"
            v-model.trim="inputText"
            autocomplete="off"
            :placeholder="searchCriteria[activeCriteria].inputPlaceholder"
            @input="validateInput"
          >
          </base-input>
        </b-form-group>
        <div class="after-input">
          <button class="btn btn-icon btn-none" v-show="inputText.length <= 0">
            <svg class="o-icon fill-gray"><use xlink:href="#search"></use></svg>
          </button>
          <button class="btn btn-icon btn-none" v-show="inputText.length > 0" @click.prevent="resetSearch">
            <svg class="o-icon stroke-black"><use xlink:href="#close-small"></use></svg>
          </button>
        </div>
      </div>
      <div class="wrapp-criteria">
        <ul class="nav wrapp-criteria-list">
          <div class="wrapp-indicator"></div>
          <li v-for="(criteria, index) in searchCriteria" :key="index" class="wrapp-criteria-list-item" :class="{'active': activeCriteria === index }">
            <button class="btn btn-none btn-rounded" @click.prevent="setCurrentCriteria(criteria, index)">
              {{criteria.label}}
            </button>
          </li>
        </ul>
      </div>
      <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster">
        <div class="search-result" v-show="readyForSearch">
          <div class="form-suggestions-results" :class="{ 'no-text': inputText === '', 'no-results': noResults }">
            <absolute-loader :showLoader="loading" minHeight="auto"></absolute-loader>
            <transition
            enter-active-class="animate__animated animate__fadeInUp"
            leave-active-class="animate__animated animate__fadeOutDown"
            mode="out-in">
              <component :is="searchCriteriaComponent" :searchResponse="searchResponse" :key="activeCriteria" :inputText="inputText" @changePage="changePage" />
            </transition>
          </div>
        </div>
      </transition>
    </b-form>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { EventBus } from '@/helpers'
// import ImgProduct from 'theme/components/Product/Image'
// import BaseInput from 'theme/components/Form/BaseInput'
// import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
// import Stores from 'theme/components/Search/manageCriteria/Stores'
// import Orders from 'theme/components/Search/manageCriteria/Orders'
// import Products from 'theme/components/Search/manageCriteria/Products'
// import Customers from 'theme/components/Search/manageCriteria/Customers'

export default {
  data () {
    return {
      loading: false,
      pagination: false,
      readyForSearch: false,
      inputText: '',
      inputIsClicked: false,
      searchResponse: null,
      searchCriteriaComponent: 'Products',
      activeCriteria: 0,
      searchCriteria: [
        {
          label: this.$t('search.products'),
          value: 'products',
          dispatchToDo: 'searchProduct',
          inputPlaceholder: this.$t('search.products-placeholder')
        },
        {
          label: this.$t('search.customers'),
          value: 'customers',
          dispatchToDo: 'searchCustomer',
          inputPlaceholder: this.$t('search.customers-placeholder')
        },
        {
          label: this.$t('search.orders'),
          value: 'orders',
          dispatchToDo: 'searchOrders',
          inputPlaceholder: this.$t('search.orders-placeholder')
        },
        {
          label: this.$t('search.stores'),
          value: 'stores',
          dispatchToDo: 'searchStores',
          inputPlaceholder: this.$t('search.stores-placeholder')
        }
      ]
    }
  },
  computed: {
    suggestions () {
      return this.$store.state.product.suggestions
    },
    noResults () {
      return this.suggestions.total_count === 0
    },
    totalCount () {
      return this.suggestions.total_count
    },
    formClass () {
      return [
        `active-criteria-${this.searchCriteria[this.activeCriteria].value}`
      ]
    }
  },
  methods: {
    submitForm () {
      if (!window.searchThrottle) {
        window.searchThrottle = debounce(this.doSubmit, 500)
      }
      window.searchThrottle()
    },
    inputClicked (payload) {
      this.inputIsClicked = payload
      this.$emit('inputIsClicked', this.inputIsClicked)
    },
    getFromScanner (code) {
      this.$store.commit('ui/setBottomActiveComponent', {})
      this.inputText = code
      this.validateInput(code)
    },
    openScanReader () {
      // add condition
      // if panel active is user: activate scanner for coin card
      // otherwise EAN scanner
      let componentToLoad = ''
      if (this.searchCriteria[this.activeCriteria].value === 'customers') {
        componentToLoad = import('theme/components/CodeScanner/CoinCardScanner')
        EventBus.$on('coin-card-scanner::detect', this.getFromScanner)
      } else {
        componentToLoad = import('theme/components/CodeScanner/EanScanner')
      }
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
    },
    setCurrentCriteria (criteria, index) {
      if (this.activeCriteria !== index) {
        this.activeCriteria = index
        this.searchCriteriaComponent = criteria.value
        this.inputText = ''
        this.searchResponse = ''
        this.validateInput(this.inputText)
        this.findActiveCriteria()
      } else {
        return false
      }
    },
    findActiveCriteria () {
      this.$nextTick(function () {
        const $activeCriteria = $('.wrapp-criteria-list .wrapp-criteria-list-item.active')
        if ($activeCriteria.length > 0) {
          const $wrappIndicator = $('.wrapp-indicator')
          let offsetLeft = $activeCriteria.position().left
          $wrappIndicator.animate({
            left: offsetLeft
          }, 300)
        }
      })
    },
    validateInput (value) {
      if (value.length) {
        this.readyForSearch = true
        EventBus.$emit('searchBar:readyForSearch', true)
        this.doSubmit()
      } else {
        this.readyForSearch = false
        EventBus.$emit('searchBar:readyForSearch', false)
      }
    },
    doSubmit: debounce(function () {
      const _this = this
      this.loading = true
      this.$store.dispatch('search/makeSearch', {
        inputText: this.inputText,
        pagination: this.pagination,
        dispatchToDo: this.searchCriteria[this.activeCriteria].dispatchToDo
      })
        .then((res) => {
          _this.searchResponse = res
        })
        .finally(() => {
          _this.loading = false
        })
    }, 700),
    resetSearch () {
      // inherit method from mixin
      $('body').removeClass('overflow-hidden')
      this.inputText = ''
      this.validateInput(this.inputText)
    },
    fitSearchToPage () {
      $('.search-result').css({
        height: ($('.grid-steps').outerHeight() - $('.form-search-wrap').outerHeight())
      })
    },
    changePage (pagination) {
      this.pagination = pagination
      $('.search-result').scrollTop(0)
      this.doSubmit()
    }
  },
  mounted () {
    if (process.client) {
      setTimeout(() => {
        this.fitSearchToPage()
        this.findActiveCriteria()
      }, 1000)
    }
  },
  destroyed () {
    EventBus.$off('coin-card-scanner::detect', this.getFromScanner)
  },
  components: {
    ImgProduct: () => import('theme/components/Product/Image'),
    BaseInput: () => import('theme/components/Form/BaseInput'),
    AbsoluteLoader: () => import('theme/components/AbsoluteLoader/AbsoluteLoader'),
    Stores: () => import('theme/components/Search/manageCriteria/Stores'),
    Orders: () => import('theme/components/Search/manageCriteria/Orders'),
    Products: () => import('theme/components/Search/manageCriteria/Products'),
    Customers: () => import('theme/components/Search/manageCriteria/Customers')
  }
}
</script>
